import manifest from './movd-media-manifest.json';

const setAtPath = (target, path, value) => {
  const parts = path.split('.');
  const last = parts.pop();
  const parent = parts.reduce((node, part) => (node[part] ||= {}), target);
  parent[last] = value;
};

export const movdMedia = manifest.assets
  .filter(asset => asset.status === 'approved' && asset.localPath)
  .reduce((index, asset) => {
    setAtPath(index, asset.semanticKey, {
      ...asset,
      src: asset.localPath,
      sizes: asset.renditions || null,
    });
    return index;
  }, {});

const inventoryAliases = {
  sectional: 'sectionalEditorial',
  loveseat: 'sofaEditorial',
  table: 'diningTable',
  diningChairs: 'diningChair',
  desk: 'deskOffice',
  officeChair: 'deskOffice',
  freezer: 'refrigerator',
  dryer: 'washerDryer',
};

Object.entries(inventoryAliases).forEach(([alias, source]) => {
  movdMedia.inventory[alias] = { ...movdMedia.inventory[source], semanticKey: `inventory.${alias}` };
});

export const mediaAsset = (semanticKey, fallbackKey = 'inventory.boxes') => {
  const resolve = (key) => key.split('.').reduce((node, segment) => node?.[segment], movdMedia);
  return resolve(semanticKey) || resolve(fallbackKey) || null;
};

export const mediaSrc = (asset, rendition = 'standard') => asset?.renditions?.[rendition] || asset?.src || '';

const inventoryImageRules = [
  ['piano', 'piano'],
  ['bicycle', 'bicycle'],
  ['exercise', 'exerciseEquipment'],
  ['coffee table', 'coffeeTable'],
  ['side table', 'coffeeTable'],
  ['tv stand', 'televisionStand'],
  ['entertainment', 'televisionStand'],
  ['television', 'television'],
  ['armchair', 'armchair'],
  ['bookshelf', 'bookshelf'],
  ['floor lamp', 'floorLamp'],
  ['large rug', 'sofaEditorial'],
  ['sofa', 'sofaEditorial'],
  ['couch', 'sofaEditorial'],
  ['refrigerator', 'refrigerator'],
  ['fridge', 'refrigerator'],
  ['dishwasher', 'dishwasher'],
  ['microwave', 'kitchenAppliances'],
  ['kitchen table', 'diningTable'],
  ['kitchen chair', 'diningChair'],
  ['stove', 'stoveOven'],
  ['oven', 'stoveOven'],
  ['kitchen island', 'kitchenIsland'],
  ['bar stool', 'barStools'],
  ['mattress', 'mattress'],
  ['bed', 'bedEditorial'],
  ['dresser', 'dresser'],
  ['nightstand', 'nightstand'],
  ['wardrobe', 'wardrobe'],
  ['chest of drawers', 'chestDrawers'],
  ['vanity', 'vanity'],
  ['dining table', 'diningTable'],
  ['dining chair', 'diningChair'],
  ['china cabinet', 'chinaCabinet'],
  ['buffet', 'sideboard'],
  ['sideboard', 'sideboard'],
  ['office chair', 'deskOffice'],
  ['filing cabinet', 'filingCabinet'],
  ['computer', 'computerSetup'],
  ['printer', 'printer'],
  ['safe', 'filingCabinet'],
  ['desk', 'deskOffice'],
  ['washing machine', 'washerDryer'],
  ['dryer', 'washerDryer'],
  ['laundry basket', 'laundryBasket'],
  ['workbench', 'workbench'],
  ['tool cabinet', 'toolCabinet'],
  ['shelving unit', 'shelvingUnit'],
  ['boxes', 'boxesEditorial'],
];

export const inventoryAssetForItem = (item) => {
  const name = String(item?.name || item || '').toLowerCase();
  const matchingRule = inventoryImageRules.find(([term]) => name.includes(term));
  return mediaAsset(`inventory.${matchingRule?.[1] || 'boxesEditorial'}`);
};

export const mediaImageProps = (asset, { priority = false, rendition = 'standard' } = {}) => asset ? {
  src: mediaSrc(asset, rendition),
  alt: asset.alt,
  loading: priority ? 'eager' : 'lazy',
  decoding: 'async',
  fetchpriority: priority ? 'high' : 'auto',
} : {};